module.exports = __webpack_public_path__ + "static/media/dice-d10.f0b16e25.svg";